import React from "react";
import { Route, Switch } from "react-router-dom";
import About from "./containers/About";
import Investors from "./containers/Investors";
import Corporate from "./containers/Corporate";

const Routes = () => {
  return (
    <Switch>
      <Route exact path="/" component={About} />
      <Route exact path="/za-nas" component={About} />
      <Route exact path="/korporativno-upravlenie" component={Corporate} />
      <Route exact path="/za-investitori/:section?/:year?" component={Investors} />
    </Switch>
  );
};

export default Routes;



// WEBPACK FOOTER //
// ./src/routes.js